(function () {
	const MOBILE_BP = 768;

	function shouldActivate(el) {
		const w = window.innerWidth;
		const hasMobile = el.classList.contains('mobile');
		const hasDesktop = el.classList.contains('desktop');
		if (hasMobile && hasDesktop) return true;
		if (hasMobile && !hasDesktop) return w < MOBILE_BP;
		if (hasDesktop && !hasMobile) return w >= MOBILE_BP;
		return false;
	}

	function initCarousel(scroller) {
		var trackEl = scroller.parentElement.querySelector('.scroll-track');
		var thumb = trackEl ? trackEl.querySelector('.scroll-thumb') : null;
		var dragging = false;
		var startX, startLeft;

		// Sync thumb position on scroll
		scroller.addEventListener('scroll', function () {
			if (!thumb || !shouldActivate(scroller)) return;
			var max = scroller.scrollWidth - scroller.clientWidth;
			if (max <= 0) return;
			var pct = scroller.scrollLeft / max;
			thumb.style.left = (pct * 75) + '%';
		});

		if (!thumb) return;

		// Drag handlers
		function onStart(e) {
			if (!shouldActivate(scroller)) return;
			dragging = true;
			startX = (e.touches ? e.touches[0] : e).clientX;
			startLeft = thumb.offsetLeft;
			scroller.style.scrollSnapType = 'none';
			thumb.style.cursor = 'grabbing';
			e.preventDefault();
		}
		function onMove(e) {
			if (!dragging) return;
			var x = (e.touches ? e.touches[0] : e).clientX;
			var dx = x - startX;
			var maxLeft = trackEl.clientWidth - thumb.clientWidth;
			var newLeft = Math.min(Math.max(0, startLeft + dx), maxLeft);
			var pct = newLeft / maxLeft;
			scroller.scrollLeft = pct * (scroller.scrollWidth - scroller.clientWidth);
		}
		function onEnd() {
			if (!dragging) return;
			dragging = false;
			scroller.style.scrollSnapType = '';
			thumb.style.cursor = '';
		}

		thumb.addEventListener('mousedown', onStart);
		thumb.addEventListener('touchstart', onStart, { passive: false });
		window.addEventListener('mousemove', onMove);
		window.addEventListener('touchmove', onMove, { passive: false });
		window.addEventListener('mouseup', onEnd);
		window.addEventListener('touchend', onEnd);
	}

	document.querySelectorAll('.carousel').forEach(initCarousel);

	// Arrow nav for .alt testimonial carousels
	document.querySelectorAll('.arrow-nav').forEach(function (nav) {
		var scroller = nav.parentElement.querySelector('.testimonial');
		if (!scroller) return;
		var left = nav.querySelector('.arrow-left');
		var right = nav.querySelector('.arrow-right');
		if (!left || !right) return;

		function getCardWidth() {
			var card = scroller.querySelector('blockquote');
			if (!card) return 300;
			return card.offsetWidth + parseFloat(getComputedStyle(scroller).gap || 0);
		}

		left.addEventListener('click', function () {
			scroller.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
		});
		right.addEventListener('click', function () {
			scroller.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
		});
	});

	// Marquee scroll for overflowing pill text on mobile
	function initMarquee() {
		var spans = document.querySelectorAll('.new-the-ask li span');
		if (!spans.length || window.innerWidth >= MOBILE_BP) return;

		var data = [];
		spans.forEach(function (span) {
			var li = span.parentElement;
			// Measure before adding .marquee class
			var spanWidth = span.scrollWidth;
			var liWidth = li.clientWidth;
			var styles = getComputedStyle(li);
			var padL = parseFloat(styles.paddingLeft);
			var padR = parseFloat(styles.paddingRight);
			var overflow = spanWidth - liWidth + padL + padR;

			if (overflow <= 0) return;

			var fullScroll = spanWidth + padL + padR + 16;

			// Add .marquee after measurement
			li.classList.add('marquee');

			data.push({ span: span, li: li, fullScroll: fullScroll, liWidth: liWidth, timer: null });
		});

		if (!data.length) return;

		// Pre-build keyframes and animation strings once
		data.forEach(function (d) {
			var scrollOutDur = d.fullScroll / 40;
			var scrollInDur = d.liWidth / 40;
			var total = scrollOutDur + scrollInDur;
			var outEnd = (scrollOutDur / total * 100).toFixed(1);
			var resetPct = (outEnd * 1 + 0.1).toFixed(1);
			var name = 'marquee-' + Math.random().toString(36).slice(2, 8);
			var sheet = document.createElement('style');
			var fadeStart = (outEnd * 1 - 0.1).toFixed(1);
			sheet.textContent = '@keyframes ' + name + ' {' +
				'0% { transform: translateX(0); opacity: 1; }' +
				fadeStart + '% { transform: translateX(-' + (d.fullScroll - 5) + 'px); opacity: 1; }' +
				outEnd + '% { transform: translateX(-' + d.fullScroll + 'px); opacity: 0; }' +
				resetPct + '% { transform: translateX(' + d.liWidth + 'px); opacity: 0; }' +
				(resetPct * 1 + 0.1).toFixed(1) + '% { transform: translateX(' + d.liWidth + 'px); opacity: 1; }' +
				'100% { transform: translateX(0); opacity: 1; }' +
			'}';
			document.head.appendChild(sheet);
			d.anim = name + ' ' + total + 's linear infinite';
			d.started = false;
		});

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				data.forEach(function (d) {
					if (d.span !== entry.target) return;
					if (entry.isIntersecting && !d.started) {
						d.started = true;
						d.timer = setTimeout(function () {
							d.span.style.animation = d.anim;
						}, 3000);
						observer.unobserve(d.span);
					}
				});
			});
		}, { threshold: 0.5 });

		data.forEach(function (d) { observer.observe(d.span); });
	}

	initMarquee();

	// Horizontal scroll hijack for .hijack-scroll on desktop
	function initHijackScroll() {
		var DESKTOP_BP = 1024;
		if (window.innerWidth < DESKTOP_BP) return;

		var el = document.querySelector('.hijack-scroll');
		if (!el) return;

		var section = el.closest('section');
		if (!section) return;

		// How far the cards need to translate horizontally
		var scrollDistance = el.scrollWidth - el.clientWidth;
		if (scrollDistance <= 0) return;

		// Wrap all section children in a sticky container
		var wrapper = document.createElement('div');
		wrapper.style.position = 'sticky';
		wrapper.style.top = '0';
		while (section.firstChild) {
			wrapper.appendChild(section.firstChild);
		}
		section.appendChild(wrapper);

		// Extend section height so there's scroll room while wrapper is stuck
		section.style.height = wrapper.offsetHeight + scrollDistance + 'px';

		var ticking = false;

		function onScroll() {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function () {
				ticking = false;
				var sectionTop = section.getBoundingClientRect().top;
				// progress: 0 when section top hits viewport top, 1 after scrollDistance
				var progress = Math.max(0, Math.min(1, -sectionTop / scrollDistance));
				el.scrollLeft = progress * scrollDistance;
			});
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	}

	initHijackScroll();

	function initRevenueChain() {
		var lists = document.querySelectorAll('.revenue-chain');
		if (!lists.length) return;
		var STEP = 500;
		function run(ul) {
			ul.classList.add('is-visible');
			var items = ul.querySelectorAll('li');
			items.forEach(function (li, i) {
				setTimeout(function () { li.classList.add('is-in'); }, i * STEP);
			});
		}
		if (!('IntersectionObserver' in window)) {
			lists.forEach(run);
			return;
		}
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				run(entry.target);
				observer.unobserve(entry.target);
			});
		}, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
		lists.forEach(function (ul) { observer.observe(ul); });
	}

	initRevenueChain();

	function initModal() {
		var overlay = document.getElementById('overlay');
		if (!overlay) return;
		document.querySelectorAll('a.modal-pop').forEach(function (a) {
			a.addEventListener('click', function (e) {
				e.preventDefault();
				var id = a.getAttribute('href').replace(/^#/, '');
				var modal = document.getElementById(id);
				if (!modal) return;
				overlay.classList.add('showing');
				modal.style.display = 'block';
			});
		});
		document.querySelectorAll('.modal-close').forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				overlay.classList.remove('showing');
				document.querySelectorAll('.modal').forEach(function (m) {
					m.style.display = 'none';
				});
			});
		});
	}

	initModal();
})();
